import { campaignMessagesTableHead } from "@assets/mocks/tableData";
import Iconify from "@components/iconify";
import * as Select from "@radix-ui/react-select";
import ReactPaginate from "react-paginate";
import { IconButton, MenuItem, Popover } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import Table from "@components/Table";
import { useNavigate } from "react-router";
import {
  Campaign,
  updateCampaignStatus,
  updateCampaignStatus1,
} from "@redux/slices/campaign";
import { Archive } from "lucide-react";
import LoadingScreen from "@components/LoadingScreen";
import axios from "axios";
import useAuth from "@hooks/useAuth";
import { Button } from "@components/ui/button";
import { useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { getUserById } from "@redux/slices/auth";

const CampaignMessages: React.FC = () => {
  const [closeMenu, setCloseMenu] = React.useState<HTMLElement | null>(null);
  const [itemOffset, setItemOffset] = useState<number>(0);
  const [campaignData, setCampaignData] = useState<Campaign[]>([]);
  const [filteredData, setFilteredData] = useState<Campaign[]>([]);
  const [selectedValue, setSelectedValue] = useState<string>("RUNNING");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Items per page

  const navigate = useNavigate();
  const { user } = useAuth();
  const selectedUserId = useSelector((state: RootState) => state.user.selectedUserId);

  useEffect(() => {
    setLoading(true);

    
    const fetchCampaigns = async (apikey: string) => {
      try {
        const response = await axios.get(
          `https://aquisize-backend-zrj2.onrender.com/api/campaigns?apiKey=${apikey}`
        );
        let filteredCampaignData;

        if (user?.role === "admin" && selectedUserId) {
          // Fetch user details based on selectedUserId
          const selectedUser = await getUserById(selectedUserId);
          if (selectedUser) {
            // Filter campaigns based on the selected user's email
            filteredCampaignData = response.data.filter(
              (campaign: any) =>
                campaign.status.toUpperCase() === selectedValue.toUpperCase() 
              // &&
                // campaign.from_email === selectedUser.email
            );
          }
        } else {
          // Filter campaigns based on the logged-in user's email
          filteredCampaignData = response.data.filter(
            (campaign: any) =>
              campaign.status.toUpperCase() === selectedValue.toUpperCase() 
            // &&
              // campaign.from_email === user?.email
          );
        }
        

        setCampaignData(filteredCampaignData);
        setFilteredData(filteredCampaignData); // Initialize filtered data with all campaigns
      } catch (err) {
        console.error("Error fetching campaigns", err);
      } finally {
        setLoading(false);
      }
    };


    

    // fetchCampaigns();

    if (user.role != "admin") {
      fetchCampaigns(user.apikey);
    } else if (user.role === "admin") {
      fetchApiKey().then((apiKey) => {
        if (apiKey != null) {
          fetchCampaigns(apiKey);
        } else if (apiKey == null) {
          setCampaignData([]);        
        }
      });
    }



  }, [selectedValue, user?.email, selectedUserId]); // Add user?.email and selectedUserId as dependencies


  const fetchApiKey = async () => {
    try {
      let apiKey: string | undefined;

      if (user?.role === "admin") {
        const selectedUser = await getUserById(selectedUserId);
        apiKey = selectedUser?.apikey; // Get the selected user's API key
      } else {
        apiKey = user?.apikey; // Get the current user's API key
      }

      if (!apiKey) {
        setLoading(false);
        return null;
      }

      console.log("API Key:", apiKey);
      return apiKey;
    } catch (error) {}
  };


  const handleSearch = (term: string) => {
    setSearchTerm(term);
    const filtered = campaignData.filter((campaign) =>
      campaign.name.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const endOffset = itemOffset + itemsPerPage;
  const paginatedData = filteredData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredData?.length / itemsPerPage);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filteredData?.length;
    setItemOffset(newOffset);
  };

  const handleCloseMenu = (event: any) => {
    setCloseMenu(event.currentTarget);
  };

  const handleCloseMenuReset = () => {
    setCloseMenu(null);
  };

  const handleChange = (value: string) => {
    setSelectedValue(value);
  };

  const handleStatusUpdate = async (id: number, val: string) => {
    await updateCampaignStatus(id, val);
    // getData(); // If there's a need to refresh data after updating the status
  };

  const handleStatusUpdate1 = async (id: number, val: string) => {
    await updateCampaignStatus1(id, val);
    // getData(); // If there's a need to refresh data after updating the status
  };

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-end items-center mt-7">
            <div className="flex items-center relative">
              <div className="me-2">
                <div className="relative">
                  <input
                    className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm transition-colors rounded-md w-full py-2.5 px-3 text-gray-800 leading-tight focus:outline-none"
                    type="text"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <div className="absolute left-0 inset-y-0 flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#71717A"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className="md:me-2 md:w-72 md:mb-0 mb-4">
              <Select.Root value={selectedValue} onValueChange={handleChange}>
                <SelectTrigger
                  className="SelectTrigger bg-white border-none"
                  aria-label="Filter"
                >
                  <SelectValue placeholder={selectedValue || "Running"} />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="RUNNING">RUNNING</SelectItem>
                  <SelectItem value="DRAFT">DRAFT</SelectItem>
                  <SelectItem value="PAUSED">PAUSED</SelectItem>
                  <SelectItem value="STOPPED">STOPPED</SelectItem>
                  <SelectItem value="COMPLETED">COMPLETED</SelectItem>
                  <SelectItem value="DELETED">DELETED</SelectItem>
                </SelectContent>
              </Select.Root>
            </div>
          </div>
          <Table textIndex={0} tableHead={campaignMessagesTableHead}>
            {paginatedData?.map((val, index) => (
              <tr
                key={index}
                className="text-sm text-gray text-center border-b last:border-0 border-[#EAECF0]"
              >
                <td
                  className="p-5 text-left cursor-pointer"
                  onClick={() => {
                    if (val?.id !== undefined) {
                      handleStatusUpdate1(val?.id, "false");
                      if (user?.role === "admin") {
                        return; // Do nothing if the user is an admin
                      }

                      navigate(
                        `/campaignMessages/campaignMessageDetail/${val.id}`
                      );
                    }
                  }}
                >
                  <div className="relative">{val?.name}</div>
                </td>

                <td
                  className={`p-5 flex justify-center ${
                    val?.status === "RUNNING"
                      ? "text-[#276C3A]"
                      : "text-[#722b2b]"
                  } font-medium`}
                >
                  <div
                    className={`${
                      val?.status === "RUNNING"
                        ? "bg-[#6AFF5D66]"
                        : "bg-[#ff5d5d66]"
                    } rounded-full px-4 w-fit py-1`}
                  >
                    {val?.status}
                  </div>
                </td>

                {user?.role == "admin" && (
                  <td>
                    <Button
                      onClick={() =>
                        navigate(`/campaignMessages/campaignMessageDetail/${val.id}`)
                      }
                    >
                      View Templates
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </Table>
          <div className="flex flex-col md:flex-row justify-between items-center mt-8 pb-32">
            <div className="me-2 w-32 md:mb-0 mb-4">
              <Select.Root
                onValueChange={(value) => {
                  setItemsPerPage(Number(value));
                  setItemOffset(0); // Reset to first page
                }}
              >
                <SelectTrigger className="SelectTrigger bg-white border-none">
                  <SelectValue placeholder={`${itemsPerPage} per Page`} />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="10">10 per page</SelectItem>
                  <SelectItem value="15">15 per page</SelectItem>
                  <SelectItem value="20">20 per page</SelectItem>
                </SelectContent>
              </Select.Root>
            </div>
            <div className="pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={window.innerWidth > 576 ? "Next →" : ">"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={window.innerWidth > 576 ? "← Prev" : "<"}
                renderOnZeroPageCount={null}
                activeClassName="bg-white"
              
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CampaignMessages;
